// quill editor
export const modules = {
  toolbar: [
	['bold', 'italic', 'underline'],   
     
	]
};
export const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "color"
];
